import React, { useState, useEffect, useCallback, useRef } from "react";
import { 
  CreateTable,
  SuccessMessage,
  FailMessage,
  Loading,
  FormatValueToDecimal,

  // DrAccountsReceivablesChartOfAccountsSelect,
  // ExpenseChartOfAccountsSelect,
  ChartOfAccountsSelect,
  CreditNoteBillPerVendorSelect, CreditNoteBillPerVendorTamperedSelect,
  CreditNoteExpensePerVendorSelect, CreditNoteExpensePerVendorTamperedSelect,
  VendorSelect,
  DateSelect,
  ConfirmationModal,
  DetectMimeTypeFromBase64, HandleFileUpload, DownloadFile,
  CreditNoteStatusSelectWithAll,
  CreditNoteTypeSelectWithAll,
  GetAccountConfiguration
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import { motion, AnimatePresence } from "framer-motion";
import NoAccess from "../NoAccess";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { JournalHeader } from "../Journals/JournalHeader";
// MUI Icons
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ListAltIcon from '@mui/icons-material/ListAlt';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PostAddIcon from '@mui/icons-material/PostAdd';
import VerifiedIcon from '@mui/icons-material/Verified';

export const CreditNotesPayable = ({active}) => {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1)
    const lowerValue = value.toLowerCase();

    const filtered = filteredData.filter(
      (item) =>
        item.creditNoteNumber?.toLowerCase().includes(lowerValue) ||
        item.vendorName1?.toLowerCase().includes(lowerValue)
    );

    setData(filtered);
  };
//#endregion






//#region Filters
  const [showFilterForm, setShowFilterForm] = useState(false);
  const [typeFilter, setTypeFilter] = useState("All");
  const [vendorFilter, setVendorFilter] = useState(null);
  const [statusFilter, setStatusFilter] = useState("All");
  const openFilterForm = () => {
    setShowFilterForm(true);
  }
  const closeFilterForm = () => {
    setShowFilterForm(false);
  }
//#endregion








//#region Variables
  const [selectedData, setSelectedData] = useState(null);

  const [vendor, setVendor] = useState(null);
  const [creditNoteDetails, setCreditNoteDetails] = useState([]);
  const [creditNoteNumber, setCreditNoteNumber] = useState("xxxxxx");
  const [amount, setAmount] = useState(0);
  const [type, setType] = useState("");

  const today = new Date().toISOString().split("T")[0];
  const [creditNoteDate, setCreditNoteDate] = useState(today);

  const [accountInit, setAccountInit] = useState(null);
  const [creditNoteAccount, setCreditNoteAccount] = useState(accountInit);
  const [referenceNumber, setReferenceNumber] = useState("");
  const [notes, setNotes] = useState("");
  const [uploadedFile, setUploadedFile] = useState("");

  const resetVariables = () => {
    setVendor(null);
    setCreditNoteDetails([]);
    setCreditNoteNumber("xxxxxx");
    setType("");
    setAmount(0);
    setCreditNoteDate(today);
    setCreditNoteAccount(accountInit);
    setReferenceNumber("");
    setNotes("");
    setUploadedFile("");

    setSelectedData(null);
  }

  const fetchDataById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/CreditNotePayable/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);

  useEffect(() => {
    const init = async () => {
      const _config = await GetAccountConfiguration("creditNote", "Payables")

      const _accountInit = {
        id: _config?.drGLAccountId ?? 0,
        accountName: _config?.drGLAccountName ?? "",
        accountNumber: _config?.drGLAccountNumber ?? "",
        isActive: true,
      }

      setAccountInit(_accountInit)
      setCreditNoteAccount(_accountInit)
    }

    init();
  }, [])
//#endregion








// #region Add function
  const [showAddForm, setShowAddForm] = useState(false);
  
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetVariables();
  }

  /* const generateNumber = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/CreditNotePayable/generate-number` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return ""
    }
  }, []); */

  const addHandleClick = async (_type) => {
    setLoading(true)

    /* const _number = await generateNumber();
    setCreditNoteNumber(_number?.number) */

    setType(_type)
    setLoading(false)
    openAddForm()
  }

  const handleAddData = async () => {
    const data = {
      creditNoteDetails: creditNoteDetails,
      vendorId: vendor?.vendorId,
      creditNoteNumber: creditNoteNumber,
      type: type,
      amount: amount,
      creditNoteDate: creditNoteDate,
      referenceNumber: referenceNumber,
      creditNoteAccountId: creditNoteAccount?.id,
      notes: notes,
      uploadedFile: uploadedFile?.base64,
      createdDate: new Date(),
      createdBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/CreditNotePayable`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion






// #region Update function
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  
  const openUpdateForm = () => {
    setShowUpdateForm(true);
  }
  const closeUpdateForm = () => {
    setShowUpdateForm(false);
    resetVariables();
  }

  const editHandleClick = async (data) => {
    setLoading(true)
    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setCreditNoteDetails(_data.creditNoteDetails ?? []);
    setVendor(_data.vendor ?? null);
    setCreditNoteNumber(_data.creditNoteNumber ?? "");
    setType(_data.type ?? "");
    setAmount(_data.amount ?? 0);
    setCreditNoteDate(_data.creditNoteDate ?? null);
    setCreditNoteAccount(_data.creditNoteAccount ?? null);
    setReferenceNumber(_data.referenceNumber ?? "");
    setNotes(_data.notes ?? "");
    setUploadedFile(_data.uploadedFile
            ? {
                base64: _data.uploadedFile,
                contentType: DetectMimeTypeFromBase64(
                  _data.uploadedFile
                ),
                fileName: `UploadedFile.${DetectMimeTypeFromBase64(
                  _data.uploadedFile
                ).split("/")[1]}`
              }
            : null)

    setLoading(false)
    openUpdateForm();
  }

  const handleUpdateData = async () => {
    const data = {
      creditNoteDetails: creditNoteDetails,
      vendorId: vendor?.vendorId,
      creditNoteNumber: creditNoteNumber,
      type: type,
      amount: amount,
      creditNoteDate: creditNoteDate,
      referenceNumber: referenceNumber,
      creditNoteAccountId: creditNoteAccount?.id,
      notes: notes,
      uploadedFile: uploadedFile?.base64,
      updatedDate: new Date(),
      updatedBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/CreditNotePayable/update/${selectedData?.id}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion







// #region View function
  const [showViewForm, setShowViewForm] = useState(false);
  
  const openViewForm = () => {
    setShowViewForm(true);
  }
  const closeViewForm = () => {
    setShowViewForm(false);
    resetVariables();
  }

  const viewHandleClick = async (data) => {
    setLoading(true)
    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setCreditNoteDetails(_data.creditNoteDetails ?? []);
    setVendor(_data.vendor ?? null);
    setCreditNoteNumber(_data.creditNoteNumber ?? "");
    setType(_data.type ?? "");
    setAmount(_data.amount ?? 0);
    setCreditNoteDate(_data.creditNoteDate ?? null);
    setCreditNoteAccount(_data.creditNoteAccount ?? null);
    setReferenceNumber(_data.referenceNumber ?? "");
    setNotes(_data.notes ?? "");
    setUploadedFile(_data.uploadedFile
            ? {
                base64: _data.uploadedFile,
                contentType: DetectMimeTypeFromBase64(
                  _data.uploadedFile
                ),
                fileName: `UploadedFile.${DetectMimeTypeFromBase64(
                  _data.uploadedFile
                ).split("/")[1]}`
              }
            : null)

    setLoading(false)
    openViewForm();
  }
//#endregion








// #region View Reference
  const [selectedReference, setSelectedReference] = useState(null);
  const [showViewReferenceForm, setShowViewReferenceForm] = useState(false);
  
  const openViewReferenceForm = () => {
    setShowViewReferenceForm(true);
  }
  const closeViewReferenceForm = () => {
    setShowViewReferenceForm(false);
    setSelectedReference(null);
  }

  const viewReferenceHandleClick = async (data) => {
    setLoading(true);
    const _data = await fetchDataById(data);
    setSelectedReference(_data?.creditNoteDetails ?? []);
    setType(_data.type)

    setLoading(false)
    openViewReferenceForm();
  }
// #endregion









// #region Post function
  const [showPostForm, setShowPostForm] = useState(false);
  
  const openPostForm = () => {
    setShowPostForm(true);
  }
  const closePostForm = () => {
    setShowPostForm(false);
    resetVariables();
  }

  const postHandleClick = async (data) => {
    setLoading(true)
    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setLoading(false)
    openPostForm();
  }
//#endregion











// #region Refund function
  const [showRefundForm, setShowRefundForm] = useState(false);
  
  const openRefundForm = () => {
    setShowRefundForm(true);
  }
  const closeRefundForm = () => {
    setShowRefundForm(false);
    resetVariables();
  }

  const refundHandleClick = async (data) => {
    setLoading(true)
    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setLoading(false)
    openRefundForm();
  }
//#endregion







//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    'CREDIT NOTE NUMBER', 
    'CUSTOMER', 
    'INVOICE/S', 
    'TOTAL AMOUNT', 
    'CREDIT AMOUNT', 
    // 'TYPE', 
    'STATUS', 
    // 'CREDIT NOTE DATE', 
    'ACTIONS',
  ]
  const accessors = [
    'creditNoteNumber', 
    'vendor', 
    'creditNoteDetails', 
    'creditNoteDetailsAmountBeforeAdjust', 
    'creditNoteDetailsAmount', 
    // 'type', 
    'status', 
    // 'creditNoteDate', 
    'actions'
  ]

  const actions = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleClick,
      visible: true,
    },
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleClick,
      visible: true,
    },
    { 
      name: "View Credit Note Detail", 
      tooltip: "view",
      icon: <ListAltIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewReferenceHandleClick,
      visible: false,
    },
    { 
      name: "Post", 
      tooltip: "post",
      icon: <PostAddIcon fontSize="small" />,
      className: "bg-orange-500 hover:bg-orange-600",
      function: postHandleClick,
      visible: false,
    },
    { 
      name: "Refund", 
      tooltip: "credit",
      icon: <VerifiedIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: refundHandleClick,
      visible: false,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/CreditNotePayable/vendor/${vendorFilter?.vendorId ?? "All"}/type/${typeFilter ? typeFilter : "All"}/status/${statusFilter ? statusFilter : "All"}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
      setFilteredData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [vendorFilter, typeFilter, statusFilter]);

  useEffect(() => {
    if(active){
      fetchData();
    }
  }, [active, fetchData])
//#endregion










//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasPayables) {
    return <NoAccess />;
  }
//#endregion



  return (
    <>
      <div className="py-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          {/* Search and Filters */}
          <div className="flex justify-between items-center gap-2 w-full">
            <div className="w-full">
              <input
                type="text"
                placeholder="Search account..."
                className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
              {/* Add filter dropdowns here if needed */}
            </div>
          </div>
          <div className="flex gap-3 w-full justify-start md:justify-end">
            <button className="bg-white border border-gray-300 text-theme-color hover:bg-gray-100 px-3 py-1 rounded-md flex items-center gap-2 hover:bg-opacity-90 transition"
              onClick={openFilterForm}
            >
              <FilterAltIcon/> Filter
            </button>
            <button onClick={()=>addHandleClick("Expenses")} className="hidden items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
              <AddCircleOutlineIcon fontSize="small" /> New CN (Expense)
            </button>
            <button onClick={()=>addHandleClick("Bills")} className="flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
              <AddCircleOutlineIcon fontSize="small" /> New Credit Note
            </button>
          </div>
        </div>

        <CreateTable
          tableName={"Credit Note"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <AddUpdateModal 
        visible={showAddForm}
        onClose={closeAddForm}
        onSave={handleAddData}
        modalName={"Add Credit Note"}

        referencePaymentHeader={selectedData}
        data={data}
        creditNoteDetails={creditNoteDetails} setCreditNoteDetails={setCreditNoteDetails}
        vendor={vendor} setVendor={setVendor}
        creditNoteNumber={creditNoteNumber} setCreditNoteNumber={setCreditNoteNumber}
        type={type} setType={setType}
        amount={amount} setAmount={setAmount}
        creditNoteDate={creditNoteDate} setCreditNoteDate={setCreditNoteDate}
        creditNoteAccount={creditNoteAccount} setCreditNoteAccount={setCreditNoteAccount}
        referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
        notes={notes} setNotes={setNotes}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        isEditable={true}
      />

      <AddUpdateModal 
        visible={showUpdateForm}
        onClose={closeUpdateForm}
        onSave={handleUpdateData}
        modalName={"Update Credit Note"}

        referencePaymentHeader={selectedData}
        data={data}
        creditNoteDetails={creditNoteDetails} setCreditNoteDetails={setCreditNoteDetails}
        vendor={vendor} setVendor={setVendor}
        creditNoteNumber={creditNoteNumber} setCreditNoteNumber={setCreditNoteNumber}
        type={type} setType={setType}
        amount={amount} setAmount={setAmount}
        creditNoteDate={creditNoteDate} setCreditNoteDate={setCreditNoteDate}
        creditNoteAccount={creditNoteAccount} setCreditNoteAccount={setCreditNoteAccount}
        referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
        notes={notes} setNotes={setNotes}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        isEditable={true}
      />

      <ViewModal 
        visible={showViewForm}
        onClose={closeViewForm}
        // onSave={handleViewData}
        modalName={"View Credit Note"}

        referencePaymentHeader={selectedData}
        data={data}
        creditNoteDetails={creditNoteDetails} setCreditNoteDetails={setCreditNoteDetails}
        vendor={vendor} setVendor={setVendor}
        creditNoteNumber={creditNoteNumber} setCreditNoteNumber={setCreditNoteNumber}
        type={type} setType={setType}
        amount={amount} setAmount={setAmount}
        creditNoteDate={creditNoteDate} setCreditNoteDate={setCreditNoteDate}
        creditNoteAccount={creditNoteAccount} setCreditNoteAccount={setCreditNoteAccount}
        referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
        notes={notes} setNotes={setNotes}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        isEditable={false}
      />

      { type === "Expenses" ? 
        <ViewCreditNoteDetailsModal 
          visible={showViewReferenceForm}
          onClose={closeViewReferenceForm}
          // onSave={handleUpdateData}
          modalName={"View Expense/s"}

          creditNoteDetails={selectedReference} setCreditNoteDetails={setSelectedReference}
        />
        :
        <ViewCreditNoteDetails2Modal 
          visible={showViewReferenceForm}
          onClose={closeViewReferenceForm}
          // onSave={handleUpdateData}
          modalName={"View Invoice/s"}

          creditNoteDetails={selectedReference} setCreditNoteDetails={setSelectedReference}
        />
      }

      <CreateJournalModal 
        visible={showPostForm}
        onClose={closePostForm}
        // onSave={handleUpdateData}
        modalName={"Create Journal"}
        isEditable={true}
        data={selectedData}
        fetchData={fetchData}
        status={"Posted"}
      />

      <CreateJournalModal 
        visible={showRefundForm}
        onClose={closeRefundForm}
        // onSave={handleUpdateData}
        modalName={"Create Journal"}
        isEditable={true}
        data={selectedData}
        fetchData={fetchData}
        status={"Refunded"}
      />

      <FilterModal 
        visible={showFilterForm}
        onClose={closeFilterForm}
        modalName={"Filter"}

        vendorFilter={vendorFilter} setVendorFilter={setVendorFilter}
        typeFilter={typeFilter} setTypeFilter={setTypeFilter}
        statusFilter={statusFilter} setStatusFilter={setStatusFilter}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
}









//#region AddUpdate/View Modal
const AddUpdateModal = ({
  visible, onClose, onSave, modalName,
  referencePaymentHeader,
  creditNoteDetails, setCreditNoteDetails,
  vendor, setVendor,
  creditNoteNumber, setCreditNoteNumber,
  type, setType,
  amount, setAmount,
  creditNoteDate, setCreditNoteDate,
  creditNoteAccount, setCreditNoteAccount,
  referenceNumber, setReferenceNumber,
  notes, setNotes,
  uploadedFile, setUploadedFile,
  isEditable
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [failMessage, setFailMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showCreditNoteDetails, setShowCreditNoteDetails] = useState(true);
  const [totalReferenceAmount, setTotalReferenceAmount] = useState(0);


//#region Vendor
  const [showVendorSelectForm, setShowVendorSelectForm] = useState(false);
  const openVendorSelectForm = () => {
    setShowVendorSelectForm(true);
  }
  const closeVendorSelectForm = () => {
    setShowVendorSelectForm(false);
  }
//#endregion







//#region Credit Note Account
  const [showCreditNoteAccountSelectForm, setShowCreditNoteAccountSelectForm] = useState(false);
  const openCreditNoteAccountSelectForm = () => {
    setShowCreditNoteAccountSelectForm(true);
  }
  const closeCreditNoteAccountSelectForm = () => {
    setShowCreditNoteAccountSelectForm(false);
  }
//#endregion








  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (!creditNoteNumber
      || !creditNoteDate
      || creditNoteDetails.length <= 0
    ) {
      setFailMessage("Please fill up all required fields. Add at least 1 sales.");
      return;
    }

    if (Number(totalReferenceAmount) !== Number(amount)) {
      setFailMessage("Please enter an amount that matches the total invoice amount.");
      return;
    }

    await onSave();
    closeModal();
  };

  const closeModal = () => {
    resetLocalVariables();
    onClose();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
    setLoading(false);
    setShowCreditNoteDetails(true);
    setTotalReferenceAmount(0);
    setSelectedCreditNoteDetails(null)
    setCurrentPageCreditNoteDetails(1)
    setShowAddCreditNoteDetailsForm(false)
    setShowUpdateCreditNoteDetailsForm(false)
    setShowViewCreditNoteDetailsForm(false)
    setShowDeleteCreditNoteDetailsForm(false)
  }








//#region Credit Note Detail
  const [selectedCreditNoteDetails, setSelectedCreditNoteDetails] = useState(null);
  const [currentPageCreditNoteDetails, setCurrentPageCreditNoteDetails] = useState(1);

  const headersCreditNoteDetailsExpense = [
    'EXPENSE NUMBER', 
    // 'ORDER NUMBER', 
    'ACCOUNT', 
    'AMOUNT', 
    'AMOUNT PAID', 
    'CREDIT AMOUNT', 
    'ACTIONS'
  ]
  const accessorsCreditNoteDetailsExpense = [
    'referenceNumber', 
    // 'orderNumber', 
    'glAccountName', 
    'totalAmount', 
    'amountPaid', 
    'creditAmount', 
    'actions'
  ]
  const headersCreditNoteDetails = [
    'INVOICE NUMBER', 
    // 'ORDER NUMBER', 
    'ACCOUNT', 
    'DUE DATE', 
    'TOTAL AMOUNT', 
    'AMOUNT DUE', 
    'PAID AMOUNT', 
    'CREDIT AMOUNT', 
    'ACTIONS'
  ]
  const accessorsCreditNoteDetails = [
    'referenceNumber', 
    // 'orderNumber', 
    'glAccountName', 
    'dueDate', 
    'totalAmount', 
    'amountDue', 
    'reference.amountPaid', 
    'creditAmount', 
    'actions'
  ]

  const [showAddCreditNoteDetailsForm, setShowAddCreditNoteDetailsForm] = useState(false);
  const openAddCreditNoteDetailsForm = () => {
    setShowAddCreditNoteDetailsForm(true);
  }
  const closeAddCreditNoteDetailsForm = () => {
    setShowAddCreditNoteDetailsForm(false);
    setSelectedCreditNoteDetails(null)
  }

  const [showUpdateCreditNoteDetailsForm, setShowUpdateCreditNoteDetailsForm] = useState(false);
  const openUpdateCreditNoteDetailsForm = () => {
    setShowUpdateCreditNoteDetailsForm(true);
  }
  const closeUpdateCreditNoteDetailsForm = () => {
    setShowUpdateCreditNoteDetailsForm(false);
    setSelectedCreditNoteDetails(null)
  }

  const editHandleCreditNoteDetailsClick = async(_data) => {
    setLoading(true)
    setSelectedCreditNoteDetails(_data)
    
    setLoading(false)
    openUpdateCreditNoteDetailsForm();
  }

  const [showViewCreditNoteDetailsForm, setShowViewCreditNoteDetailsForm] = useState(false);
  const openViewCreditNoteDetailsForm = () => {
    setShowViewCreditNoteDetailsForm(true);
  }
  const closeViewCreditNoteDetailsForm = () => {
    setShowViewCreditNoteDetailsForm(false);
    setSelectedCreditNoteDetails(null)
  }

  const viewHandleCreditNoteDetailsClick = (_data) => {
    setSelectedCreditNoteDetails(_data)
    openViewCreditNoteDetailsForm();
  }

  const [showDeleteCreditNoteDetailsForm, setShowDeleteCreditNoteDetailsForm] = useState(false);
  const openDeleteCreditNoteDetailsForm = () => {
    setShowDeleteCreditNoteDetailsForm(true);
  }
  const closeDeleteCreditNoteDetailsForm = () => {
    setShowDeleteCreditNoteDetailsForm(false);
    setSelectedCreditNoteDetails(null)
  }

  const deleteHandleCreditNoteDetailsClick = (_data) => {
    setSelectedCreditNoteDetails(_data)
    openDeleteCreditNoteDetailsForm();
  }

  const handleDeleteCreditNoteDetails = () => {
    setCreditNoteDetails(prev =>
      prev.filter(item =>
        (item.referenceNumber  !== selectedCreditNoteDetails.referenceNumber)
      )
    );
  };

  const actionsCreditNoteDetails = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleCreditNoteDetailsClick,
      visible: isEditable === false,
    },
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleCreditNoteDetailsClick,
      visible: isEditable === true,
    },
    { 
      name: "Delete", 
      tooltip: "delete",
      icon: <DeleteForeverIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: deleteHandleCreditNoteDetailsClick,
      visible: isEditable === true,
    },
  ];

  useEffect(() => {
    const _amount = creditNoteDetails?.reduce((acc, item) => acc + (Number(item.creditAmount) || 0), 0) || 0;
    setTotalReferenceAmount(_amount)
    setAmount(_amount)
  }, [creditNoteDetails, setTotalReferenceAmount, setAmount])
//#endregion 






  const handleFileChange = async (e) => {
    const fileData = await HandleFileUpload(e);

    if (fileData) {
      setUploadedFile(fileData);
    }
  };




  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Related Parties */}
                <>
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Related Parties</h3>
                  </div>

                  {isEditable && modalName !== "Update Credit Note"?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Vendor <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Vendor"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${vendor ? `${vendor?.vendorId} - ${vendor?.name1}` : ""}`}
                          readOnly
                        />
                        {!vendor ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openVendorSelectForm}>
                            <PersonSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setVendor(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                    :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Vendor <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Vendor"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${vendor ? `${vendor?.vendorId} - ${vendor?.name1}` : ""}`}
                          readOnly
                        />
                      </div>
                    </div>
                  }

                  <div>
                  </div>
                </>
              </div>
                
              {/* Wrap everything in a relative container */}
              <div className="relative mt-10">
                
                {/* The Overlay: Only shows if !vendor */}
                {!vendor && (
                  <div className="absolute inset-0 z-10 flex items-center justify-center bg-gray-50/60 backdrop-blur-[1px] rounded-xl border-2 border-dashed border-gray-200">
                    <div className="bg-white px-6 py-3 rounded-full shadow-xl border border-amber-200 flex items-center gap-3 animate-pulse">
                      <div className="bg-amber-100 p-1 rounded-full">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-600" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <span className="text-sm font-bold text-gray-700 uppercase tracking-tight">
                        Please select vendor first
                      </span>
                    </div>
                  </div>
                )}

                {/* Your Content: We add opacity-40 if no vendor to make it look "disabled" */}
                <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 transition-opacity duration-300 ${!vendor ? 'opacity-40 pointer-events-none p-5' : 'opacity-100'}`}>
                  <>
                    <div className="space-y-4 md:col-span-2 mt-5">
                      <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Payment</h3>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Credit Note Number <span className="text-red-500">*</span>
                      </label>
                      <input
                        placeholder="0000000"
                        className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                        value={creditNoteNumber}
                        onChange={(e) => setCreditNoteNumber(e.target.value)}
                        readOnly
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Credit Note Date <span className="text-red-500">*</span>
                      </label>
                      <DateSelect data={creditNoteDate} setData={setCreditNoteDate} isEditable={true}/>
                    </div>
                  </>
                </div>

                {vendor && (
                  <>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {/* --- Section 2: Credit Note Details (Expandable) --- */}
                      <div className="md:col-span-2 mt-10">
                        {/* Toggle Header Button */}
                        <button
                          type="button"
                          onClick={() => setShowCreditNoteDetails(!showCreditNoteDetails)}
                          className="flex items-center justify-between w-full border-b pb-2 group hover:border-theme-color transition-colors"
                        >
                          <div className="flex items-center gap-2">
                            <h3 className={`text-xs font-bold uppercase tracking-wider transition-colors ${showCreditNoteDetails ? 'text-theme-color' : 'text-gray-400'}`}>
                              {type === "Bills" ? "Bills to adjust" : "Expenses to adjust"}
                            </h3>
                            {/* Badge showing count */}
                            {creditNoteDetails?.length > 0 && (
                              <span className="bg-gray-200 text-gray-600 text-[10px] px-2 py-0.5 rounded-full font-bold">
                                {creditNoteDetails.length}
                              </span>
                            )}
                          </div>
                          
                          <div className={`transform transition-transform duration-300 text-gray-400 group-hover:text-theme-color ${showCreditNoteDetails ? "rotate-180" : ""}`}>
                            <ExpandMoreIcon /> 
                          </div>
                        </button>

                        {/* Expandable Content Area */}
                        <AnimatePresence>
                          {showCreditNoteDetails && (
                            <motion.div
                              initial={{ height: 0, opacity: 0 }}
                              animate={{ height: "auto", opacity: 1 }}
                              exit={{ height: 0, opacity: 0 }}
                              transition={{ duration: 0.3, ease: "easeInOut" }}
                              className="overflow-hidden"
                            >
                              <div className="py-5 space-y-5">
                                {/* Add button */}
                                <div className="flex gap-3 w-full justify-start">
                                  {isEditable &&
                                    <button 
                                      type="button"
                                      onClick={openAddCreditNoteDetailsForm} 
                                      className="flex items-center gap-2 bg-theme-color text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md active:scale-95"
                                    >
                                      <AddCircleOutlineIcon fontSize="small" /> 
                                      {type === "Bills" ? "New Invoice" : "New Expense"}
                                    </button>
                                  }
                                </div>

                                {/* List of Credit Note Detail */}
                                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                                  <CreateTable
                                    tableName={"Credit Note Detail"}
                                    headers={type === "Expenses" ? headersCreditNoteDetailsExpense : headersCreditNoteDetails}
                                    accessors={type === "Expenses" ? accessorsCreditNoteDetailsExpense : accessorsCreditNoteDetails}
                                    data={creditNoteDetails}
                                    actions={actionsCreditNoteDetails}
                                    currentPage={currentPageCreditNoteDetails}
                                    setCurrentPage={setCurrentPageCreditNoteDetails}
                                    itemsPerPage={10}
                                    totalItems={creditNoteDetails?.length}
                                  />
                                </div>
                              </div>
                            </motion.div>
                          )}
                        </AnimatePresence>

                        {/* Summary when collapsed (Optional) */}
                        {!showCreditNoteDetails && creditNoteDetails?.length > 0 && (
                          <motion.p 
                            // initial={{ opacity: 0 }} 
                            // animate={{ opacity: 1 }} 
                            className="text-[11px] text-gray-400 mt-2 italic"
                          >
                            Click to view {creditNoteDetails.length} line items...
                          </motion.p>
                        )}
                      </div>

                      {/* --- Section 3: Final Summary --- */}
                      <div className="md:col-span-2">
                        <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                          
                          {/* Left Side: Details Breakdown */}
                          <div className="flex gap-4 w-full lg:w-auto">
                            <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                              <AccountBalanceWalletIcon className="text-theme-color" />
                            </div>
                            
                            <div className="flex-1 space-y-3">
                              <div>
                                <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                                  Transaction Summary
                                </p>
                                <p className="text-xs text-gray-500">Breakdown of all line items</p>
                              </div>
                            </div>
                          </div>

                          {/* Right Side: Final Total & Status */}
                          <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                            <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                              Final Credit Amount
                            </p>
                            <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                              <span className="text-4xl font-black text-gray-900 tracking-tight">
                                {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalReferenceAmount)}`}
                              </span>
                            </div>

                            {/* Visual indicator of validation */}
                            {amount > 0 ? (
                              <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                                <span className="mr-1">●</span> Ready to Save
                              </span>
                            ) : (
                              <span className="inline-flex items-center text-[10px] font-bold text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-amber-100">
                                <span className="mr-1">○</span> No amount detected
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">Reference #</label>
                        <input
                          placeholder="0000-0000"
                          className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={referenceNumber}
                          onChange={(e) => setReferenceNumber(e.target.value)}
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">
                          (Dr) Account Receivable <span className="text-red-500">*</span>
                        </label>
                        <div className="flex flex-row items-center">
                          <input
                            type="text"
                            placeholder="Select Account"
                            className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                            value={creditNoteAccount?.accountName || ""}
                            readOnly
                          />
                          {!creditNoteAccount ? (
                            <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCreditNoteAccountSelectForm}>
                              <ManageSearchIcon className="text-white" />
                            </button>
                          ) : (
                            <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={() => setCreditNoteAccount(null)}>
                              <RemoveCircleIcon className="text-white" />
                            </button>
                          )}
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">Amount</label>
                        <input
                          type="number"
                          placeholder="0.00"
                          className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                        />
                        <div className="text-xs text-gray-500 flex items-center gap-1">
                          <span className="font-semibold text-gray-400 italic">
                            {getCurrency?.symbol ?? ""}
                            {FormatValueToDecimal(amount || 0)}
                          </span>
                        </div>
                      </div>

                      {/* Full Width: Notes */}
                      <div className="md:col-span-2">
                        <label className="block text-sm font-semibold mb-1 text-gray-700">Notes</label>
                        <textarea
                          rows="3"
                          placeholder="Enter any additional details or remarks..."
                          className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={notes}
                          onChange={(e) => setNotes(e.target.value)}
                          readOnly={!isEditable}
                        />
                      </div>
                    </div>

                    <div className="mt-6 space-y-2">
                      <label className="text-[11px] font-bold uppercase tracking-widest text-gray-400 ml-1">Attachment</label>
                      
                      <div className={`relative group transition-all duration-200 rounded-xl border-2 border-dashed 
                        ${uploadedFile ? 'border-theme-color/30 bg-theme-color/5' : 'border-gray-200 hover:border-theme-color/50 bg-gray-50/50 hover:bg-white'}`}>
                        
                        {/* Hidden Input - clickable over the whole area */}
                        {isEditable && (
                          <input
                            type="file"
                            onChange={handleFileChange}
                            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                          />
                        )}
      
                        <div className="p-4 flex items-center justify-between gap-4">
                          <div className="flex items-center gap-3">
                            {/* Icon based on state */}
                            <div className={`p-2.5 rounded-lg ${uploadedFile ? 'bg-theme-color text-white' : 'bg-gray-200 text-gray-500'}`}>
                              {uploadedFile ? (
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                              ) : (
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                </svg>
                              )}
                            </div>
      
                            <div>
                              <p className={`text-sm font-semibold truncate max-w-[200px] ${uploadedFile ? 'text-gray-800' : 'text-gray-500'}`}>
                                {uploadedFile ? uploadedFile.fileName : "Click to upload file"}
                              </p>
                              <p className="text-[11px] text-gray-400 font-medium">
                                {uploadedFile ? (uploadedFile.contentType || "Document") : "Support any file format"}
                              </p>
                            </div>
                          </div>
      
                          {/* Action Button */}
                          {uploadedFile && (
                            <button
                              type="button"
                              onClick={(e) => { e.stopPropagation(); DownloadFile(uploadedFile); }}
                              className="relative z-20 flex items-center gap-2 px-4 py-2 text-xs font-bold text-theme-color bg-white border border-theme-color/20 rounded-lg shadow-sm hover:bg-theme-color hover:text-white transition-all"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                              </svg>
                              DOWNLOAD
                            </button>
                          )}
                        </div>
                      </div>
                      
                      {!uploadedFile && <p className="text-[10px] text-gray-400 italic ml-1">* No file attached yet</p>}
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
      
      <VendorSelect 
        visible={showVendorSelectForm} 
        onClose={closeVendorSelectForm}
        modalName={"Select Vendor"}
        data={vendor} setData={setVendor}
      />

      { type === "Expenses" ? 
        <>
          <AddUpdateCreditNoteDetailsModal 
            visible={showAddCreditNoteDetailsForm} 
            onClose={closeAddCreditNoteDetailsForm}
            modalName={"Add Expense"}
            parentModalName={modalName}
            data={selectedCreditNoteDetails}
            referencePaymentHeader={referencePaymentHeader}
            creditNoteDetails={creditNoteDetails} setCreditNoteDetails={setCreditNoteDetails}
            vendor={vendor}
            isEditable={true}
          />

          <AddUpdateCreditNoteDetailsModal 
            visible={showUpdateCreditNoteDetailsForm} 
            onClose={closeUpdateCreditNoteDetailsForm}
            modalName={"Update Expense"}
            parentModalName={modalName}
            data={selectedCreditNoteDetails}
            referencePaymentHeader={referencePaymentHeader}
            creditNoteDetails={creditNoteDetails} setCreditNoteDetails={setCreditNoteDetails}
            vendor={vendor}
            isEditable={true}
          />

          <AddUpdateCreditNoteDetailsModal 
            visible={showViewCreditNoteDetailsForm} 
            onClose={closeViewCreditNoteDetailsForm}
            modalName={"View Expense"}
            parentModalName={modalName}
            data={selectedCreditNoteDetails}
            referencePaymentHeader={referencePaymentHeader}
            creditNoteDetails={creditNoteDetails} setCreditNoteDetails={setCreditNoteDetails}
            vendor={vendor}
            isEditable={false}
          />
        </>
        :
        <>
          <AddUpdateCreditNoteDetails2Modal 
            visible={showAddCreditNoteDetailsForm} 
            onClose={closeAddCreditNoteDetailsForm}
            modalName={"Add Invoice"}
            parentModalName={modalName}
            data={selectedCreditNoteDetails}
            referencePaymentHeader={referencePaymentHeader}
            creditNoteDetails={creditNoteDetails} setCreditNoteDetails={setCreditNoteDetails}
            vendor={vendor}
            isEditable={true}
          />

          <AddUpdateCreditNoteDetails2Modal 
            visible={showUpdateCreditNoteDetailsForm} 
            onClose={closeUpdateCreditNoteDetailsForm}
            modalName={"Update Invoice"}
            parentModalName={modalName}
            data={selectedCreditNoteDetails}
            referencePaymentHeader={referencePaymentHeader}
            creditNoteDetails={creditNoteDetails} setCreditNoteDetails={setCreditNoteDetails}
            vendor={vendor}
            isEditable={true}
          />

          <AddUpdateCreditNoteDetails2Modal 
            visible={showViewCreditNoteDetailsForm} 
            onClose={closeViewCreditNoteDetailsForm}
            modalName={"View Invoice"}
            parentModalName={modalName}
            data={selectedCreditNoteDetails}
            referencePaymentHeader={referencePaymentHeader}
            creditNoteDetails={creditNoteDetails} setCreditNoteDetails={setCreditNoteDetails}
            vendor={vendor}
            isEditable={false}
          />
        </>
      }
      
      <ConfirmationModal 
        visible={showDeleteCreditNoteDetailsForm} 
        onClose={closeDeleteCreditNoteDetailsForm} 
        onSave={handleDeleteCreditNoteDetails} 
        modalName={"Delete"} 
        message={`Do you want to remove this account [ ${selectedCreditNoteDetails?.referenceNumber} ]?.`}
      />

      {/* <DrAccountsReceivablesChartOfAccountsSelect  */}
      <ChartOfAccountsSelect 
        visible={showCreditNoteAccountSelectForm} 
        onClose={closeCreditNoteAccountSelectForm}
        modalName={"Select Account"}
        data={creditNoteAccount} setData={setCreditNoteAccount}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
      
      { loading && <Loading />}
    </>
  );
};
const ViewModal = ({
  visible, onClose, onSave, modalName,
  creditNoteDetails, // Array of CreditNoteDetail
  vendor, // Object containing Name1, VendorId, etc.
  creditNoteNumber,
  amount,
  creditNoteDate,
  creditNoteAccount,
  referenceNumber,
  notes,
  type,
  uploadedFile,
  isEditable
}) => {
  
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const printRef = useRef();
  const [isDownloading, setIsDownloading] = useState(false);

  // Helper for currency formatting
  const formatVal = (num) => {
    return typeof FormatValueToDecimal === "function" 
      ? FormatValueToDecimal(num) 
      : Number(num || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });
  };

  const downloadHandleClick = async () => {
    const element = printRef.current;
    if (!element) return;

    setIsDownloading(true);
    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        windowWidth: 1200,
        windowHeight: element.scrollHeight
      });

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save(`CreditNote_${creditNoteNumber || 'Export'}.pdf`);
    } catch (error) {
      console.error("PDF Generation Error:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleSubmit = async () => {
    await downloadHandleClick();
  };

  const closeModal = () => {
    onClose();
  };

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Modal Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Credit Note transaction summary</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar bg-gray-100">
              <div
                ref={printRef}
                className="max-w-4xl mx-auto bg-white shadow-xl border border-gray-200 rounded-sm p-12 min-h-[800px] flex flex-col"
              >
                {/* 1. TOP HEADER - CREDIT NOTE INFO */}
                <div className="flex justify-between items-start border-b-4 border-theme-color pb-8 mb-8">
                  <div>
                    <h1 className="text-4xl font-black text-theme-color tracking-tighter mb-2">CREDIT NOTE</h1>
                    <div className="flex items-center gap-4">
                      <div className="flex flex-col">
                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Reference #</span>
                        <span className="text-sm font-bold text-gray-700">{referenceNumber || "---"}</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Credit Note Number</p>
                    <p className="text-2xl font-mono font-bold text-gray-900">#{creditNoteNumber || 'DRAFT'}</p>
                    <p className="mt-4 text-[10px] font-bold text-gray-400 uppercase tracking-widest">Date Issued</p>
                    <p className="text-sm font-bold text-gray-800">{creditNoteDate ? new Date(creditNoteDate).toLocaleDateString('en-US', { dateStyle: 'long' }) : 'N/A'}</p>
                  </div>
                </div>

                {/* 2. CUSTOMER DETAILS SECTION */}
                <div className="grid grid-cols-2 gap-8 mb-10 bg-gray-50 p-6 rounded-xl border border-gray-100">
                  <div>
                    <p className="text-[10px] font-bold text-theme-color uppercase tracking-widest mb-2">Credited To:</p>
                    <h2 className="text-xl font-bold text-gray-900">{vendor?.name1 || vendor?.Name1 || 'Walk-in Vendor'}</h2>
                    <p className="text-xs text-gray-500 font-medium mt-1">Vendor ID: {vendor?.vendorId || vendor?.VendorId || 'N/A'}</p>
                  </div>
                  <div className="text-right flex flex-col justify-end">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">CREDIT ACCOUNT</p>
                    <p className="text-xs text-gray-600 italic">{`${creditNoteAccount?.accountNumber} - ${creditNoteAccount?.accountName}`}</p>
                  </div>
                </div>

                {/* 3. CREDIT DETAILS TABLE */}
                <div className="flex-grow">
                  <div className="mb-4">
                    <h3 className="text-[11px] font-bold text-gray-900 uppercase tracking-widest flex items-center gap-2">
                      Invoice Adjustments
                      <span className="h-[1px] flex-1 bg-gray-100"></span>
                    </h3>
                  </div>
                  <table className="w-full">
                    <thead>
                      <tr className="border-b-2 border-gray-900">
                        <th className="py-3 text-left text-[10px] font-bold uppercase tracking-widest text-gray-400">Reference #</th>
                        <th className="py-3 text-left text-[10px] font-bold uppercase tracking-widest text-gray-400">Invoice Date</th>
                        <th className="py-3 text-left text-[10px] font-bold uppercase tracking-widest text-gray-400">Revenue</th>
                        <th className="py-3 text-right text-[10px] font-bold uppercase tracking-widest text-gray-400">Paid Before</th>
                        <th className="py-3 text-right text-[10px] font-bold uppercase tracking-widest text-gray-900">Credit Applied</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                      {creditNoteDetails?.length > 0 ? (
                        creditNoteDetails.map((detail, idx) => (
                          <tr key={idx} className="hover:bg-gray-50/50">
                            <td className="py-4">
                              <p className="text-sm font-bold text-gray-800">
                                {detail.reference?.referenceNumber || detail.referenceNumber || '---'}
                              </p>
                            </td>
                            <td className="py-4 text-sm text-gray-600">
                              {detail.reference?.referenceDate ? new Date(detail.reference.referenceDate).toLocaleDateString() : 'N/A'}
                            </td>
                            <td className="py-4 text-sm text-gray-600">
                              {detail.glAccountName ? detail.glAccountName : 'N/A'}
                            </td>
                            <td className="py-4 text-right text-sm font-medium text-gray-400">
                              {getCurrency?.symbol} {formatVal(detail.amountBeforeAdjust)}
                            </td>
                            <td className="py-4 text-right text-sm font-bold text-theme-color">
                              {getCurrency?.symbol} {formatVal(detail.creditAmount)}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="py-10 text-center text-sm text-gray-400 italic">No invoice adjustments found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* 4. TOTALS & REMARKS */}
                <div className="mt-10 pt-10 border-t-2 border-gray-900">
                  <div className="flex justify-between items-start">
                    <div className="max-w-md">
                      <h4 className="text-[10px] font-black text-gray-900 uppercase tracking-widest mb-2">Reason / Remarks</h4>
                      <p className="text-xs text-gray-500 leading-relaxed italic border-l-4 border-theme-color pl-4">
                        {notes || "No additional remarks provided for this credit note."}
                      </p>
                    </div>

                    <div className="text-gray-900 p-8 text-right min-w-[300px] rounded-bl-3xl">
                      <p className="text-[10px] font-bold uppercase tracking-[0.2em] mb-1 opacity-70">Total Credited Amount</p>
                      <p className="text-4xl font-black">
                        {getCurrency?.symbol} {formatVal(amount)}
                      </p>
                      <div className="mt-4 pt-4 border-t border-white/20">
                        <p className="text-[9px] italic opacity-60 uppercase tracking-tighter">This credit is non-refundable and applicable to future balances</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Modal Footer Buttons */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Close
              </button>
              <button
                onClick={handleSubmit}
                disabled={isDownloading}
                className={`px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm flex items-center gap-2 ${isDownloading ? 'opacity-70 cursor-not-allowed' : 'hover:opacity-90'}`}
              >
                {isDownloading ? (
                    <>
                      <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                      Generating PDF...
                    </>
                ) : 'Download Credit Note'}
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    </>
  );
};
//#endregion














//#region Credit Note Details EXPENSE
const AddUpdateCreditNoteDetailsModal = ({
  visible, onClose, onSave, modalName, parentModalName,
  data, referencePaymentHeader,
  creditNoteDetails, setCreditNoteDetails,
  isEditable,
  vendor
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");

  const [failMessage, setFailMessage] = useState("");
  const [reference, setReference] = useState(null);
  const [glAccount, setGLAccount] = useState(null);
  const [amountPaid, setAmountPaid] = useState(0);

  const [showGLAccountSelectForm, setShowGLAccountSelectForm] = useState(false);
  const openGLAccountSelectForm = () => {
    setShowGLAccountSelectForm(true);
  }
  const closeGLAccountSelectForm = () => {
    setShowGLAccountSelectForm(false);
  }


  const [showReferenceSelectForm, setShowReferenceSelectForm] = useState(false);
  const openReferenceSelectForm = () => {
    setShowReferenceSelectForm(true);
  }
  const closeReferenceSelectForm = () => {
    setShowReferenceSelectForm(false);
  }

  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (!reference) {
      setFailMessage("Please fill up all required fields (Expense, Paid Through, and Amount).");
      return;
    }

    if(modalName === "Add Expense"){
      const foundData = creditNoteDetails.find(i => i.referenceId === reference.id)

      if (foundData) {
        setFailMessage("Already added this account.");
        return;
      }

      const newData = {
        glAccountId: glAccount?.id,
        glAccountName: glAccount?.accountName,
        glAccountNumber: glAccount?.accountNumber,
        glAccount: glAccount,
        referenceId: reference?.id,
        reference: reference,
        referenceNumber: reference?.expenseNumber,
        orderNumber: reference?.orderNumber,
        dueDate: reference?.dueDate,
        totalAmount: reference?.totalAmount,
        amountDue: reference?.amountDue,
        amountBeforeAdjust: reference?.totalAmount,
        creditAmount: Number(amountPaid),
        amountPaid: reference?.paidAmount,
      }

      setCreditNoteDetails((prev) => [...prev, newData])
    }

    if(modalName === "Update Expense"){
      const foundData = creditNoteDetails.find(i => i.referenceId === reference.id && data?.referenceId !== reference.id)

      if (foundData) {
        setFailMessage("Already added this account.");
        return;
      }

      const newData = {
        glAccountId: glAccount?.id,
        glAccountName: glAccount?.accountName,
        glAccountNumber: glAccount?.accountNumber,
        glAccount: glAccount,
        referenceId: reference?.id,
        reference: reference,
        referenceNumber: reference?.expenseNumber,
        orderNumber: reference?.orderNumber,
        dueDate: reference?.dueDate,
        totalAmount: reference?.totalAmount,
        amountDue: reference?.amountDue,
        amountBeforeAdjust: reference?.totalAmount,
        creditAmount: Number(amountPaid),
        amountPaid: reference?.paidAmount,
      }

      setCreditNoteDetails(prev =>
        prev.map(item =>
          item.referenceId === data?.referenceId
            ? newData
            : item
        )
      );
    }

    closeModal();
  };

  const resetLocalVariables = () => {
    setReference(null)
    setAmountPaid(0)
  }

  const closeModal = () => {
    setFailMessage("");
    onClose();
    resetLocalVariables();
  };

  useEffect(() => {
    if(visible){
      setReference(data?.reference ?? null)
      setAmountPaid(data?.creditAmount ?? 0)
      setGLAccount(data?.glAccount ?? null)
    }
  }, [visible, data])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <>
                  {/* --- Section 1: Entities --- */}
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Basic Details</h3>
                  </div>

                  { isEditable ?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Expense <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Account"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={reference?.expenseNumber || ""}
                          readOnly
                        />
                        {!reference ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openReferenceSelectForm}>
                            <ManageSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setReference(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                    :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Expense <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Account"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={reference?.expenseNumber || ""}
                          readOnly
                        />
                      </div>
                    </div>
                  }

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      (Cr) Revenue Account <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-row items-center">
                      <input
                        type="text"
                        placeholder="Select Account"
                        className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                        value={glAccount?.accountName || ""}
                        readOnly
                      />
                      {!glAccount ?
                        <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openGLAccountSelectForm}>
                          <ManageSearchIcon className="text-white"/>
                        </button> 
                        :
                        <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setGLAccount(null)}>
                          <RemoveCircleIcon className="text-white"/>
                        </button>
                      }
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Credit Amount <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-row items-center">
                      <input
                        type="number"
                        className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                        value={amountPaid}
                        onChange={(e) => setAmountPaid(e.target.value)}
                        readOnly={!isEditable}
                      />
                    </div>
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <span className="font-semibold text-gray-400 italic">
                        {getCurrency?.symbol ?? ""}
                        {FormatValueToDecimal(amountPaid || 0)}
                      </span>
                    </div>
                  </div>

                  <div className="md:col-span-2">
                    <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                      
                      <div className="flex gap-4 w-full lg:w-auto">
                        <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                          <AccountBalanceWalletIcon className="text-theme-color" />
                        </div>
                        
                        <div className="flex-1 space-y-3">
                          <div>
                            <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                              Credit Note Summary
                            </p>
                            <p className="text-xs text-gray-500">Transaction breakdown</p>
                          </div>

                          <div className="grid grid-cols-1 gap-2 border-t border-gray-50 pt-3">
                            {/* Reference Amount */}
                            <div className="flex justify-between items-center gap-8">
                              <span className="text-xs font-medium text-gray-500">Expense Amount</span>
                              <span className="text-sm font-semibold text-gray-700">
                                {getCurrency?.symbol} {FormatValueToDecimal(reference?.totalAmount)}
                              </span>
                            </div>
                            
                            {/* Amount Paid */}
                            <div className="flex justify-between items-center gap-8">
                              <span className="text-xs font-medium text-gray-500">Amount Paid</span>
                              <span className="text-sm font-semibold text-green-600">
                                {getCurrency?.symbol} {FormatValueToDecimal(
                                  modalName === "Update Expense" && data && reference ? Number(reference?.totalAmount) - Number(reference?.amountDue) 
                                  : reference?.paidAmount
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100 hidden">
                        <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                          Total Amount Due
                        </p>
                        <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                          <span className="text-4xl font-black text-gray-900 tracking-tight">
                            {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(
                              modalName === "Update Expense" && data && reference ? Number(reference?.amountDue)
                              : reference?.amountDue
                            )}`}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
      
      {parentModalName === "Update Credit Note" ?
        <CreditNoteExpensePerVendorTamperedSelect 
          visible={showReferenceSelectForm} 
          onClose={closeReferenceSelectForm}
          modalName={"Select Expense"}
          data={reference} setData={setReference}
          referencePaymentHeader={referencePaymentHeader}
          vendor={vendor}
        /> 
      :
        <CreditNoteExpensePerVendorSelect 
          visible={showReferenceSelectForm} 
          onClose={closeReferenceSelectForm}
          modalName={"Select Expense"}
          data={reference} setData={setReference}
          vendor={vendor}
        />
      }

      {/* <ExpenseChartOfAccountsSelect  */}
      <ChartOfAccountsSelect 
        visible={showGLAccountSelectForm} 
        onClose={closeGLAccountSelectForm}
        modalName={"Select Account"}
        data={glAccount} setData={setGLAccount}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
const ViewCreditNoteDetailsModal = ({
  visible, onClose, onSave, modalName,
  creditNoteDetails, setCreditNoteDetails,
}) => {
  
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [amount, setAmount] = useState(0);
  const [totalReferenceAmount, setTotalReferenceAmount] = useState(0);

  const closeModal = () => {
    onClose();
  };

  const [currentPageCreditNoteDetails, setCurrentPageCreditNoteDetails] = useState(1);

  const [selectedCreditNoteDetails, setSelectedCreditNoteDetails] = useState(null);
  const [showViewCreditNoteDetailsForm, setShowViewCreditNoteDetailsForm] = useState(false);
  const openViewCreditNoteDetailsForm = () => {
    setShowViewCreditNoteDetailsForm(true);
  }
  const closeViewCreditNoteDetailsForm = () => {
    setShowViewCreditNoteDetailsForm(false);
    setSelectedCreditNoteDetails(null)
  }

  const viewHandleCreditNoteDetailsClick = (_data) => {
    setSelectedCreditNoteDetails(_data)
    openViewCreditNoteDetailsForm();
  }

  const headersCreditNoteDetails = [
    'EXPENSE NUMBER', 
    'ACCOUNT', 
    'TOTAL AMOUNT', 
    'AMOUNT PAID', 
    'CREDIT AMOUNT', 
    'ACTIONS'
  ]
  const accessorsCreditNoteDetails = [
    'referenceNumber', 
    'glAccountName', 
    'totalAmount', 
    'reference.paidAmount', 
    'creditAmount', 
    'actions'
  ]

  const actionsCreditNoteDetails = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleCreditNoteDetailsClick,
      visible: true,
    },
  ];

  useEffect(() => {
    const _amount = creditNoteDetails?.reduce((acc, item) => acc + (Number(item.creditAmount) || 0), 0) || 0;
    setTotalReferenceAmount(_amount)
  }, [creditNoteDetails, setAmount])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="py-5 space-y-5">
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                  <CreateTable
                    tableName={"Credit Note Detail"}
                    headers={headersCreditNoteDetails}
                    accessors={accessorsCreditNoteDetails}
                    data={creditNoteDetails}
                    actions={actionsCreditNoteDetails}
                    currentPage={currentPageCreditNoteDetails}
                    setCurrentPage={setCurrentPageCreditNoteDetails}
                    itemsPerPage={10}
                    totalItems={creditNoteDetails?.length}
                  />
                </div>

                <div className="md:col-span-2">
                  <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                    
                    {/* Left Side: Details Breakdown */}
                    <div className="flex gap-4 w-full lg:w-auto">
                      <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                        <AccountBalanceWalletIcon className="text-theme-color" />
                      </div>
                      
                      <div className="flex-1 space-y-3">
                        <div>
                          <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                            Transaction Summary
                          </p>
                          <p className="text-xs text-gray-500">Breakdown of all line items</p>
                        </div>
                      </div>
                    </div>

                    {/* Right Side: Final Total & Status */}
                    <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                      <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                        Final Credit Amount
                      </p>
                      <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                        <span className="text-4xl font-black text-gray-900 tracking-tight">
                          {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalReferenceAmount)}`}
                        </span>
                      </div>

                      {/* Visual indicator of validation */}
                      {amount > 0 ? (
                        <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                          <span className="mr-1">●</span> Ready to Save
                        </span>
                      ) : (
                        <span className="inline-flex items-center text-[10px] font-bold text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-amber-100">
                          <span className="mr-1">○</span> No amount detected
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <AddUpdateCreditNoteDetailsModal 
        visible={showViewCreditNoteDetailsForm} 
        onClose={closeViewCreditNoteDetailsForm}
        modalName={"View Expense"}
        parentModalName={modalName}
        data={selectedCreditNoteDetails}
        creditNoteDetails={creditNoteDetails} setCreditNoteDetails={setCreditNoteDetails}
        // vendor={vendor}
        isEditable={false}
      />
    </>
  );
};
//#endregion











//#region Credit Note Details BILL
const AddUpdateCreditNoteDetails2Modal = ({
  visible, onClose, onSave, modalName, parentModalName,
  data, referencePaymentHeader,
  creditNoteDetails, setCreditNoteDetails,
  isEditable,
  vendor
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");

  const [failMessage, setFailMessage] = useState("");
  const [reference, setReference] = useState(null);
  const [glAccount, setGLAccount] = useState(null);
  const [amountPaid, setAmountPaid] = useState(0);

  const [showGLAccountSelectForm, setShowGLAccountSelectForm] = useState(false);
  const openGLAccountSelectForm = () => {
    setShowGLAccountSelectForm(true);
  }
  const closeGLAccountSelectForm = () => {
    setShowGLAccountSelectForm(false);
  }


  const [showReferenceSelectForm, setShowReferenceSelectForm] = useState(false);
  const openReferenceSelectForm = () => {
    setShowReferenceSelectForm(true);
  }
  const closeReferenceSelectForm = () => {
    setShowReferenceSelectForm(false);
  }

  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (!reference) {
      setFailMessage("Please fill up all required fields (Invoice, Paid Through, and Amount).");
      return;
    }

    if(modalName === "Add Invoice"){
      const foundData = creditNoteDetails.find(i => i.referenceId === reference.id)

      if (foundData) {
        setFailMessage("Already added this account.");
        return;
      }

      const newData = {
        glAccountId: glAccount?.id,
        glAccountName: glAccount?.accountName,
        glAccountNumber: glAccount?.accountNumber,
        glAccount: glAccount,
        referenceId: reference?.id,
        reference: reference,
        referenceNumber: reference?.billNumber,
        orderNumber: reference?.orderNumber,
        dueDate: reference?.dueDate,
        totalAmount: reference?.totalAmount,
        amountDue: reference?.amountDue,
        amountBeforeAdjust: reference?.totalAmount,
        creditAmount: Number(amountPaid),
        amountPaid: reference?.paidAmount,
      }

      setCreditNoteDetails((prev) => [...prev, newData])
    }

    if(modalName === "Update Invoice"){
      const foundData = creditNoteDetails.find(i => i.referenceId === reference.id && data?.referenceId !== reference.id)

      if (foundData) {
        setFailMessage("Already added this account.");
        return;
      }

      const newData = {
        glAccountId: glAccount?.id,
        glAccountName: glAccount?.accountName,
        glAccountNumber: glAccount?.accountNumber,
        glAccount: glAccount,
        referenceId: reference?.id,
        reference: reference,
        referenceNumber: reference?.billNumber,
        orderNumber: reference?.orderNumber,
        dueDate: reference?.dueDate,
        totalAmount: reference?.totalAmount,
        amountDue: reference?.amountDue,
        amountBeforeAdjust: reference?.totalAmount,
        creditAmount: Number(amountPaid),
        amountPaid: reference?.paidAmount,
      }

      setCreditNoteDetails(prev =>
        prev.map(item =>
          item.referenceId === data?.referenceId
            ? newData
            : item
        )
      );
    }

    closeModal();
  };

  const resetLocalVariables = () => {
    setReference(null)
    setAmountPaid(0)
  }

  const closeModal = () => {
    setFailMessage("");
    onClose();
    resetLocalVariables();
  };

  useEffect(() => {
    if(visible){
      setReference(data?.reference ?? null)
      setAmountPaid(data?.creditAmount ?? 0)
      setGLAccount(data?.glAccount ?? null)
    }
  }, [visible, data])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <>
                  {/* --- Section 1: Entities --- */}
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Basic Details</h3>
                  </div>

                  { isEditable ?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Invoice <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Account"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={reference?.billNumber || ""}
                          readOnly
                        />
                        {!reference ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openReferenceSelectForm}>
                            <ManageSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setReference(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                    :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Invoice <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Account"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={reference?.billNumber || ""}
                          readOnly
                        />
                      </div>
                    </div>
                  }

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      (Cr) Revenue Account <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-row items-center">
                      <input
                        type="text"
                        placeholder="Select Account"
                        className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                        value={glAccount?.accountName || ""}
                        readOnly
                      />
                      {!glAccount ?
                        <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openGLAccountSelectForm}>
                          <ManageSearchIcon className="text-white"/>
                        </button> 
                        :
                        <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setGLAccount(null)}>
                          <RemoveCircleIcon className="text-white"/>
                        </button>
                      }
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Credit Amount <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-row items-center">
                      <input
                        type="number"
                        className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                        value={amountPaid}
                        onChange={(e) => setAmountPaid(e.target.value)}
                        readOnly={!isEditable}
                      />
                    </div>
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <span className="font-semibold text-gray-400 italic">
                        {getCurrency?.symbol ?? ""}
                        {FormatValueToDecimal(amountPaid || 0)}
                      </span>
                    </div>
                  </div>

                  <div className="md:col-span-2">
                    <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                      
                      <div className="flex gap-4 w-full lg:w-auto">
                        <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                          <AccountBalanceWalletIcon className="text-theme-color" />
                        </div>
                        
                        <div className="flex-1 space-y-3">
                          <div>
                            <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                              Credit Note Summary
                            </p>
                            <p className="text-xs text-gray-500">Transaction breakdown</p>
                          </div>

                          <div className="grid grid-cols-1 gap-2 border-t border-gray-50 pt-3">
                            {/* Reference Amount */}
                            <div className="flex justify-between items-center gap-8">
                              <span className="text-xs font-medium text-gray-500">Invoice Amount</span>
                              <span className="text-sm font-semibold text-gray-700">
                                {getCurrency?.symbol} {FormatValueToDecimal(reference?.totalAmount)}
                              </span>
                            </div>
                            
                            {/* Amount Paid */}
                            <div className="flex justify-between items-center gap-8">
                              <span className="text-xs font-medium text-gray-500">Amount Paid</span>
                              <span className="text-sm font-semibold text-green-600">
                                {getCurrency?.symbol} {FormatValueToDecimal(
                                  modalName === "Update Invoice" && data && reference ? Number(reference?.totalAmount) - Number(reference?.amountDue) 
                                  : reference?.amountPaid
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100 hidden">
                        <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                          Total Amount Due
                        </p>
                        <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                          <span className="text-4xl font-black text-gray-900 tracking-tight">
                            {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(
                              modalName === "Update Invoice" && data && reference ? Number(reference?.amountDue)
                              : reference?.amountDue
                            )}`}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
      
      {parentModalName === "Update Credit Note" ?
        <CreditNoteBillPerVendorTamperedSelect 
          visible={showReferenceSelectForm} 
          onClose={closeReferenceSelectForm}
          modalName={"Select Invoice"}
          data={reference} setData={setReference}
          referencePaymentHeader={referencePaymentHeader}
          vendor={vendor}
        /> 
      :
        <CreditNoteBillPerVendorSelect 
          visible={showReferenceSelectForm} 
          onClose={closeReferenceSelectForm}
          modalName={"Select Invoice"}
          data={reference} setData={setReference}
          vendor={vendor}
        />
      }

      {/* <ExpenseChartOfAccountsSelect  */}
      <ChartOfAccountsSelect 
        visible={showGLAccountSelectForm} 
        onClose={closeGLAccountSelectForm}
        modalName={"Select Account"}
        data={glAccount} setData={setGLAccount}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
const ViewCreditNoteDetails2Modal = ({
  visible, onClose, onSave, modalName,
  creditNoteDetails, setCreditNoteDetails,
}) => {
  
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [amount, setAmount] = useState(0);
  const [totalReferenceAmount, setTotalReferenceAmount] = useState(0);

  const closeModal = () => {
    onClose();
  };

  const [currentPageCreditNoteDetails, setCurrentPageCreditNoteDetails] = useState(1);

  const [selectedCreditNoteDetails, setSelectedCreditNoteDetails] = useState(null);
  const [showViewCreditNoteDetailsForm, setShowViewCreditNoteDetailsForm] = useState(false);
  const openViewCreditNoteDetailsForm = () => {
    setShowViewCreditNoteDetailsForm(true);
  }
  const closeViewCreditNoteDetailsForm = () => {
    setShowViewCreditNoteDetailsForm(false);
    setSelectedCreditNoteDetails(null)
  }

  const viewHandleCreditNoteDetailsClick = (_data) => {
    setSelectedCreditNoteDetails(_data)
    openViewCreditNoteDetailsForm();
  }

  const headersCreditNoteDetails = [
    'INVOICE NUMBER', 
    'ACCOUNT', 
    'TOTAL AMOUNT', 
    'AMOUNT PAID', 
    'CREDIT AMOUNT', 
    'ACTIONS'
  ]
  const accessorsCreditNoteDetails = [
    'referenceNumber', 
    'glAccountName', 
    'totalAmount', 
    'reference.amountPaid', 
    'creditAmount', 
    'actions'
  ]

  const actionsCreditNoteDetails = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleCreditNoteDetailsClick,
      visible: true,
    },
  ];

  useEffect(() => {
    const _amount = creditNoteDetails?.reduce((acc, item) => acc + (Number(item.creditAmount) || 0), 0) || 0;
    setTotalReferenceAmount(_amount)
  }, [creditNoteDetails, setAmount])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="py-5 space-y-5">
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                  <CreateTable
                    tableName={"Credit Note Detail"}
                    headers={headersCreditNoteDetails}
                    accessors={accessorsCreditNoteDetails}
                    data={creditNoteDetails}
                    actions={actionsCreditNoteDetails}
                    currentPage={currentPageCreditNoteDetails}
                    setCurrentPage={setCurrentPageCreditNoteDetails}
                    itemsPerPage={10}
                    totalItems={creditNoteDetails?.length}
                  />
                </div>

                <div className="md:col-span-2">
                  <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                    
                    {/* Left Side: Details Breakdown */}
                    <div className="flex gap-4 w-full lg:w-auto">
                      <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                        <AccountBalanceWalletIcon className="text-theme-color" />
                      </div>
                      
                      <div className="flex-1 space-y-3">
                        <div>
                          <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                            Transaction Summary
                          </p>
                          <p className="text-xs text-gray-500">Breakdown of all line items</p>
                        </div>
                      </div>
                    </div>

                    {/* Right Side: Final Total & Status */}
                    <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                      <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                        Final Credit Amount
                      </p>
                      <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                        <span className="text-4xl font-black text-gray-900 tracking-tight">
                          {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalReferenceAmount)}`}
                        </span>
                      </div>

                      {/* Visual indicator of validation */}
                      {amount > 0 ? (
                        <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                          <span className="mr-1">●</span> Ready to Save
                        </span>
                      ) : (
                        <span className="inline-flex items-center text-[10px] font-bold text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-amber-100">
                          <span className="mr-1">○</span> No amount detected
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <AddUpdateCreditNoteDetailsModal 
        visible={showViewCreditNoteDetailsForm} 
        onClose={closeViewCreditNoteDetailsForm}
        modalName={"View Expense"}
        parentModalName={modalName}
        data={selectedCreditNoteDetails}
        creditNoteDetails={creditNoteDetails} setCreditNoteDetails={setCreditNoteDetails}
        // vendor={vendor}
        isEditable={false}
      />
    </>
  );
};
//#endregion











//#region Filter
const FilterModal = ({
  visible, onClose, modalName,
  vendorFilter, setVendorFilter,
  typeFilter, setTypeFilter,
  statusFilter, setStatusFilter,
}) => {
  const [failMessage, setFailMessage] = useState("");
  const [_vendorFilter, _setVendorFilter] = useState(vendorFilter);
  const [_typeFilter, _setTypeFilter] = useState(typeFilter);
  const [_statusFilter, _setStatusFilter] = useState(statusFilter);

  useEffect(() => {
    if(visible){
      _setVendorFilter(vendorFilter)
      _setTypeFilter(typeFilter)
      _setStatusFilter(statusFilter)
    }
  }, [visible, vendorFilter, typeFilter, statusFilter])

  const handleSubmit = async () => {
    setVendorFilter(_vendorFilter);
    setTypeFilter(_typeFilter);
    setStatusFilter(_statusFilter);
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

//#region Vendor
  const [showVendorSelectForm, setShowVendorSelectForm] = useState(false);
  const openVendorSelectForm = () => {
    setShowVendorSelectForm(true);
  }
  const closeVendorSelectForm = () => {
    setShowVendorSelectForm(false);
  }
//#endregion

  if (!visible) return null;

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            // initial={{ opacity: 0 }}
            // animate={{ opacity: 1 }}
            // exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-lg p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                <div>
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Vendor <span className="text-red-500">*</span>
                  </label>
                  <div className="flex flex-row items-center">
                    <input
                      type="text"
                      placeholder="Select Vendor"
                      className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                      value={`${_vendorFilter ? `${_vendorFilter?.vendorId} - ${_vendorFilter?.name1}` : ""}`}
                      readOnly
                    />
                    {!_vendorFilter ?
                      <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openVendorSelectForm}>
                        <PersonSearchIcon className="text-white"/>
                      </button> 
                      :
                      <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>_setVendorFilter(null)}>
                        <RemoveCircleIcon className="text-white"/>
                      </button>
                    }
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">
                    Type
                  </label>
                  <CreditNoteTypeSelectWithAll data={_typeFilter} setData={_setTypeFilter} isEditable={true}/>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">
                    Status
                  </label>
                  <CreditNoteStatusSelectWithAll data={_statusFilter} setData={_setStatusFilter} isEditable={true}/>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <VendorSelect 
        visible={showVendorSelectForm} 
        onClose={closeVendorSelectForm}
        modalName={"Select Vendor"}
        data={_vendorFilter} setData={_setVendorFilter}
      />

      {/* Alert */}
      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
//#endregion







//#region Journal
const CreateJournalModal = ({
  visible, onClose, onSave, modalName,
  data, fetchData,
  isEditable, status,
}) => {
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [loading, setLoading] = useState(false)
  const [journalLines, setJournalLines] = useState([])
  const [documentNumber, setDocumentNumber] = useState("") 
  const [vendor, setVendor] = useState(null) 
  const [documentType, setDocumentType] = useState(null)
  const [documentDate, setDocumentDate] = useState(null)
  const today = new Date().toISOString().split("T")[0];
  const [postingDate, setPostingDate] = useState(today)
  const [fiscalYear, setFiscalYear] = useState("")
  const [fiscalPeriod, setFiscalPeriod] = useState("")
  const [currency, setCurrency] = useState("PHP")
  const [referenceNumber, setReferenceNumber] = useState("")
  const [documentHeaderText, setDocumentHeaderText] = useState("")

  const accountData = JSON.parse(localStorage.getItem("accountData"));

  const generateNumber = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/Journal/generate-number` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return ""
    }
  }, []);

  const fetchNumber = useCallback(async () => {
    setLoading(true)

    const _number = await generateNumber();
    setDocumentNumber(_number?.number)

    setLoading(false)
  }, [generateNumber])

  useEffect(() => {
    if (visible && !documentNumber) {
      fetchNumber()
      setVendor(data?.vendor ?? null)
      setVendor(data?.vendor ?? null)

      const _documentType = {
        id: 1,
        description: "Accounts Payable",
        isActive: true
      }

      setDocumentType(_documentType)
      setDocumentDate(data?.documentDate)
      setReferenceNumber(data?.documentNumber)
    }
  }, [visible, documentNumber, fetchNumber, data])

  const handleAddData = async () => {
    const data = {
      journalLines: journalLines,
      vendorId: vendor?.vendorId,
      documentNumber: documentNumber,
      documentTypeId: documentType?.id,
      documentSubType: status === "Posted" ? "Credit Note" : "Credit Note Credited",
      documentDate: documentDate,
      postingDate: postingDate,
      fiscalYear: fiscalYear,
      fiscalPeriod: fiscalPeriod,
      currency: currency,
      referenceNumber: referenceNumber,
      documentHeaderText: documentHeaderText,
      createdDate: new Date(),
      createdBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/Journal/status/${status}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 

  const handleSubmit = async () => {
    if(!documentNumber
      || !documentType
      || !postingDate
      || !currency
      || journalLines.length <= 0
    ){
      setFailMessage("Please fill up all required fields.")
      return;
    }

    await handleAddData();
    closeModal();
  };

  const resetLocalVariables = () => {
    setJournalLines([])
    setDocumentNumber("")
    setVendor(null)
    setVendor(null)
    setDocumentType(null)
    setDocumentDate(null)
    setPostingDate(today)
    setFiscalYear("")
    setFiscalPeriod("")
    setCurrency("PHP")
    setReferenceNumber("")
    setDocumentHeaderText("")
  }

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  }

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{`${modalName}`}</h2>
                <p className="text-sm text-gray-500">{`Document Number: ${documentNumber}`}</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <JournalHeader 
                type={"AP"}
                isEditable={true}
                documentNumber={documentNumber} setDocumentNumber={setDocumentNumber}
                journalLines={journalLines} setJournalLines={setJournalLines}
                vendor={vendor} setVendor={setVendor}
                documentType={documentType} setDocumentType={setDocumentType}
                documentDate={documentDate} setDocumentDate={setDocumentDate}
                postingDate={postingDate} setPostingDate={setPostingDate}
                fiscalYear={fiscalYear} setFiscalYear={setFiscalYear}
                fiscalPeriod={fiscalPeriod} setFiscalPeriod={setFiscalPeriod}
                currency={currency} setCurrency={setCurrency}
                referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
                documentHeaderText={documentHeaderText} setDocumentHeaderText={setDocumentHeaderText}
                documentData={data}
              />
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Create Journal
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
};
//#endregion